module.exports = __webpack_public_path__ + "media/images/general/icon_new_tab-813a950694931f1f6983a9a9802e25bc.svg";